import { RuleModel } from "@/src/shared/models/rule";

export const runBlocklyScript = (rules: RuleModel[] | undefined, context: Object) => {
    rules?.forEach((rule) => {
        if (typeof rule.code === 'string' && rule.code.length) {
            const runScripts = new Function("context", rule.code);
            runScripts(context);
        }
    });
}